import Body from 'commons/card/Body';
import { default as Card } from 'commons/card/CollapsableCard';
import Header from 'commons/card/Header';
import * as r from 'constants/routes';
import PropTypes from 'prop-types';
import React, { useMemo } from 'react';
import AnnonceFactory from './factories/AnnonceFactory';
import DiffuseurFactory from './factories/DiffuseurFactory';
import DocumentFactory from './factories/DocumentFactory';
import NoteFactory from './factories/NoteFactory';
import PlanificationProduitFactory from './factories/PlanificationProduitFactory';
import ProduitAssigneGlobauxFactory from './factories/ProduitAssigneGlobauxFactory';
import StatsFactory from './factories/StatsFactory';

export default function CampaignBuilder(props) {
  const factories = useMemo(
    () => ({
      AnnonceFactory: {
        label: 'Annonces',
        component: AnnonceFactory
      },
      PlanificationProduitFactory: {
        label: 'Planification campagne',
        component: PlanificationProduitFactory
      },
      DiffuseurFactory: {
        label: 'Diffuseurs',
        component: DiffuseurFactory
      },
      ProduitAssigneGlobauxFactory: {
        label: 'Produits assignés globaux',
        type_url: r.CAMPAGNE_TYPE_PROD,
        component: ProduitAssigneGlobauxFactory,
      },
      DistributeurFactory: {
        label: 'Distributeurs',
        component: DiffuseurFactory
      },
      DocumentFactory: {
        label: 'Documents',
        component: DocumentFactory
      },
      NoteFactory: {
        label: 'Notes',
        component: NoteFactory
      },
      StatsFactory: {
        label: 'Statistiques (À venir)',
        component: StatsFactory
      }
    }),
    []
  );

  const blogue = useMemo(
    () => [
      factories.PlanificationProduitFactory,
      factories.ProduitAssigneGlobauxFactory,
      factories.DocumentFactory,
      factories.NoteFactory,
      factories.StatsFactory
    ],
    [
      factories.NoteFactory,
      factories.ProduitAssigneGlobauxFactory,
      factories.DocumentFactory,
      factories.PlanificationProduitFactory,
      factories.StatsFactory
    ]
  );
  const affNumerique = useMemo(
    () => [
      factories.DocumentFactory,
      factories.ProduitAssigneGlobauxFactory,
      factories.NoteFactory,
      factories.StatsFactory
    ],
    [
      factories.DocumentFactory,
      factories.ProduitAssigneGlobauxFactory,
      factories.NoteFactory,
      factories.StatsFactory
    ]
  );
  const circulaire = useMemo(
    () => [
      factories.PlanificationProduitFactory,
      factories.ProduitAssigneGlobauxFactory,
      factories.DistributeurFactory,
      factories.DocumentFactory,
      factories.NoteFactory,
      factories.StatsFactory
    ],
    [
      factories.PlanificationProduitFactory,
      factories.DistributeurFactory,
      factories.DocumentFactory,
      factories.NoteFactory,
      factories.ProduitAssigneGlobauxFactory,
      factories.StatsFactory
    ]
  );
  const infolettre = useMemo(
    () => [
      factories.PlanificationProduitFactory,
      factories.ProduitAssigneGlobauxFactory,
      factories.DocumentFactory,
      factories.NoteFactory,
      factories.StatsFactory
    ],
    [
      factories.PlanificationProduitFactory,
      factories.ProduitAssigneGlobauxFactory,
      factories.DocumentFactory,
      factories.NoteFactory,
      factories.StatsFactory]
  );
  const journal = useMemo(
    () => [
      factories.PlanificationProduitFactory,
      factories.ProduitAssigneGlobauxFactory,
      factories.DocumentFactory,
      factories.NoteFactory,
      factories.StatsFactory
    ],
    [
      factories.PlanificationProduitFactory,
      factories.ProduitAssigneGlobauxFactory,
      factories.DocumentFactory,
      factories.NoteFactory,
      factories.StatsFactory
    ]
  );
  const post = useMemo(
    () => [
      factories.PlanificationProduitFactory,
      factories.ProduitAssigneGlobauxFactory,
      factories.DocumentFactory,
      factories.NoteFactory,
      factories.StatsFactory
    ], [
    factories.PlanificationProduitFactory,
    factories.ProduitAssigneGlobauxFactory,
    factories.DocumentFactory,
    factories.NoteFactory,
    factories.StatsFactory
  ]
  );
  const radio = useMemo(
    () => [
      factories.PlanificationProduitFactory,
      factories.ProduitAssigneGlobauxFactory,
      factories.AnnonceFactory,
      factories.DiffuseurFactory,
      factories.DocumentFactory,
      factories.NoteFactory,
      factories.StatsFactory
    ],
    [
      factories.AnnonceFactory,
      factories.DiffuseurFactory,
      factories.DocumentFactory,
      factories.NoteFactory,
      factories.PlanificationProduitFactory,
      factories.ProduitAssigneGlobauxFactory,
      factories.StatsFactory
    ]
  );
  const siteWeb = useMemo(
    () => [
      factories.PlanificationProduitFactory,
      factories.ProduitAssigneGlobauxFactory,
      factories.DocumentFactory,
      factories.NoteFactory,
      factories.StatsFactory
    ], [
    factories.PlanificationProduitFactory,
    factories.DocumentFactory,
    factories.ProduitAssigneGlobauxFactory,
    factories.NoteFactory,
    factories.StatsFactory
  ]
  );
  const tv = useMemo(
    () => [
      factories.PlanificationProduitFactory,
      factories.ProduitAssigneGlobauxFactory,
      factories.AnnonceFactory,
      factories.DiffuseurFactory,
      factories.DocumentFactory,
      factories.NoteFactory,
      factories.StatsFactory
    ],
    [
      factories.AnnonceFactory,
      factories.DiffuseurFactory,
      factories.DocumentFactory,
      factories.NoteFactory,
      factories.PlanificationProduitFactory,
      factories.ProduitAssigneGlobauxFactory,
      factories.StatsFactory
    ]
  );
  const vendSilencieux = useMemo(
    () => [
      factories.ProduitAssigneGlobauxFactory,
      factories.DocumentFactory,
      factories.NoteFactory,
      factories.StatsFactory
    ],
    [
      factories.DocumentFactory,
      factories.ProduitAssigneGlobauxFactory,
      factories.NoteFactory,
      factories.StatsFactory
    ]
  );

  const videowall = useMemo(
    () => [
      factories.ProduitAssigneGlobauxFactory,
      factories.DiffuseurFactory,
      factories.DocumentFactory,
      factories.NoteFactory,
      factories.StatsFactory
    ],
    [
      factories.DiffuseurFactory,
      factories.DocumentFactory,
      factories.NoteFactory,
      factories.ProduitAssigneGlobauxFactory,
      factories.StatsFactory
    ]
  );

  const Numeric = useMemo(() =>
    [
      factories.PlanificationProduitFactory,
      factories.ProduitAssigneGlobauxFactory,
      factories.DocumentFactory,
      factories.NoteFactory,
      factories.StatsFactory
    ],
    [
      factories.PlanificationProduitFactory,
      factories.ProduitAssigneGlobauxFactory,
      factories.NoteFactory,
      factories.DocumentFactory,
      factories.StatsFactory
    ]);

  const affExterieur = useMemo(() =>
    [
      factories.PlanificationProduitFactory,
      factories.ProduitAssigneGlobauxFactory,
      factories.DocumentFactory,
      factories.NoteFactory,
      factories.StatsFactory
    ],
    [
      factories.PlanificationProduitFactory,
      factories.ProduitAssigneGlobauxFactory,
      factories.NoteFactory,
      factories.DocumentFactory,
      factories.StatsFactory
    ]);

    const abribus = useMemo(() =>
    [
      factories.PlanificationProduitFactory,
      factories.ProduitAssigneGlobauxFactory,
      factories.DocumentFactory,
      factories.NoteFactory,
      factories.StatsFactory
    ],
    [
      factories.PlanificationProduitFactory,
      factories.ProduitAssigneGlobauxFactory,
      factories.NoteFactory,
      factories.DocumentFactory,
      factories.StatsFactory
    ]);

  const types = useMemo(
    () => ({
      Numerique: Numeric,
      Post: post,
      Blogue: blogue,
      'Aff-Numerique': affNumerique,
      'Aff-Exterieur': affExterieur,
      Abribus: abribus,
      Journal: journal,
      Circulaire: circulaire,
      Infolettre: infolettre,
      Radio: radio,
      VideoWall: videowall,
      'Vend-Silencieux': vendSilencieux,
      Tv: tv,
      SiteWeb: siteWeb
    }),
    [Numeric, affNumerique, blogue, circulaire, infolettre, journal, post, radio, siteWeb, tv, vendSilencieux, videowall]
  );

  const cardsContainner = useMemo(() => {
    let allCards =
      types[props.media.key] === undefined
        ? [
          <Card canCollapse={false} key={'card'} type="error">
            <Header title="Média inexistant"></Header>
            <Body></Body>
          </Card>,
        ]
        : types[props.media.key].map((card) => (
          <card.component
            key={card.label + 'detail'}
            card={card}
            data={props.data}
            media={props.media}
          ></card.component>
        ));
    return <div>{allCards}</div>;
  }, [props.data, props.media, types]);

  return cardsContainner;
}

CampaignBuilder.propTypes = {
  data: PropTypes.object,
  media: PropTypes.shape({
    key: PropTypes.any,
  }),
};
